import { gql } from "@apollo/client";

export const getUsers = gql`
  query getUsers($url: String) {
    users(url: $url) {
      id
      email
      username
      url
      token
      resetToken
      resetTokenExpiry
      role
      desc
      timezone
      calendar
    }
  }
`;
export const getRatings = gql`
  query getRatings($eventId: Int!) {
    getRatings(eventId: $eventId) {
      id
      eventId
      bookingId
      review
      rating
      desc
    }
  }
`;
export const getCompanyHours = gql`
  query getCompanyHours(
    $userId: Int!
    $groupId: Int
    $hours24: String
    $sorted: Boolean
  ) {
    getCompanyHours(
      userId: $userId
      groupId: $groupId
      hours24: $hours24
      sorted: $sorted
    ) {
      id
      userId
      day
      onJob
      startTime
      endTime
      groupId
    }
  }
`;
export const getOverrides = gql`
  query getOverrides($userId: Int!, $hours24: String) {
    getOverrides(userId: $userId, hours24: $hours24) {
      id
      userId
      startTime
      endTime
      groupId
    }
  }
`;
export const getOverrideGroups = gql`
  query getOverrideGroups($userId: Int!) {
    getOverrideGroups(userId: $userId) {
      id
      userId
      date
      groupId
    }
  }
`;
export const getBookings = gql`
  query getBookings($userId: Int) {
    getBookings(userId: $userId) {
      id
      eventId
      timezone
      bookingId
      time
      createdAt
      status
    }
  }
`;
export const GET_SUBSCRIPTIONS = gql`
  query getSubscriptions($userId: Int!) {
    getSubscriptions(userId: $userId) {
      id
      role
      type
      subscribedOnDate
      unsubscribedOnDate
    }
  }
`;
export const GET_EVENTS = gql`
  query GetCompanyEvents($companyId: Int!) {
    getCompanyEvents(companyId: $companyId) {
      id
      title
      start
      end
      location
      status
      locationType
      desc
      color
      link
      length
      companyId
      groupId
      maxInvitees
      showRemaining
      eventType
      bookingOption
      increments
      eventsPerDay
      hidden
      phoneNumber
      phoneNumberRadio
      image
      bookingApproval
    }
  }
`;
export const ALL_EVENTS = gql`
  query GetCompanyEvents {
    getEvents {
      id
      title
      start
      end
      location
      status
      locationType
      desc
      color
      link
      length
      companyId
      groupId
      maxInvitees
      showRemaining
      eventType
      increments
      eventsPerDay
      hidden
      phoneNumber
      phoneNumberRadio
      bookingOption
      bookingApproval
      image
    }
  }
`;
export const getCompanyGroupsHours = gql`
  query getCompanyGroupsHours($userId: Int!, $custom: Boolean) {
    getCompanyGroupsHours(userId: $userId, custom: $custom) {
      id
      userId
      def
      title
      custom
    }
  }
`;
export const getInviteeQuestions = gql`
  query getInviteeQuestions($eventId: Int, $userId: Int) {
    getInviteeQuestions(eventId: $eventId, userId: $userId) {
      id
      title
      type
      required
      eventId
    }
  }
`;
export const getInviteeAnswers = gql`
  query getInviteeAnswers($eventId: Int!) {
    getInviteeAnswers(eventId: $eventId) {
      id
      title
      questionId
    }
  }
`;
export const getBookingAnswers = gql`
  query getBookingAnswers($userId: Int!) {
    getBookingAnswers(userId: $userId) {
      id
      answer
      questionId
      bookingId
    }
  }
`;
export const GET_INTEGRATION = gql`
  query getIntegration($integration: String!) {
    getIntegration(integration: $integration) {
      id
      name
      logo
      description
      tags
    }
  }
`;
export const GET_INTEGRATIONS = gql`
  query getIntegrations {
    getIntegrations {
      id
      name
      logo
      description
      tags
    }
  }
`;
export const GET_USER_INTEGRATIONS = gql`
  query getUserIntegrations($userId: Int!) {
    getUserIntegrations(userId: $userId) {
      integrationId
    }
  }
`;
export const GET_ALL_TAGS = gql`
  query {
    getAllTags
  }
`;
